import React from 'react';
import ReactDOM from 'react-dom';
import App from './App'; // Import the App component
import 'assets/css/App.css'; // Import styles

ReactDOM.render(
  <App />,
  document.getElementById('root')
);